import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next';
import { LocalKeyMap } from '@/local';
import styles from './footerCopy.module.scss'
import { useNavigate, useLocation } from 'react-router-dom';

const FooterCopy = (props) => {
  const { theme = 'dark' } = props
  const { t } = useTranslation();
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <div className={`${styles.content}`}>
      <div className={`${styles.footer} ${styles[theme]}`} id="footer">
        <ul className={styles.list}>
          <li onClick={()=>{
            navigate('/uBoxMachine/doc?slug=user.agreement&platform=web')
          }}>
            {t(LocalKeyMap['login.termsService'])}
          </li>
          <li onClick={()=>{
            navigate('/uBoxMachine/doc?slug=user.qa&platform=web')
          }}>FAQ·お問い合わせ</li>
          <li onClick={()=>{
            navigate('/uBoxMachine/doc?slug=privacy.policy&platform=web')
          }}>イバシーポリシー</li>
          <li onClick={()=>{
            navigate('/uBoxMachine/doc?slug=delivery.rule&platform=web')
          }}>特定商取引法に基づく表記</li>
        </ul>
        <div className={styles.text}>
          <p>会社名:UBOX株式会社</p>
          {/* <p>電話番号:08057640790</p> */}
          <p>場所:東京都文京区本郷四丁目16番6-1006H</p>
        </div>
      </div>
    </div>
  )
}

export default FooterCopy
